// Which devotional a given day shows.
//
// The rotation is per day and per language, not global. A day rotates over the
// number of *distinct* devotionals written for it, which is not the same as the
// number of rows: the Chinese prose was deliberately kept the same across years,
// so on 218 of 364 days the traditional text has two distinct devotionals where
// English has three. Counting rows instead of content would show a reader the
// same devotional twice inside one cycle.
//
// Adding a variation for a day lengthens that day's rotation and leaves every
// other day alone.

export const CYCLE_ANCHOR = 2026;

// The fields that decide whether two rows are the same devotional. Audio and
// link columns are left out: a differing mp3 URL for identical prose is still
// the same devotional to a reader.
const CONTENT_FIELDS = [
  'topic', 'key_verse', 'emphasis', 'musing', 'prayer', 'hymn_title', 'ls_title',
];

export function contentSignature(row) {
  return CONTENT_FIELDS.map(f => String(row?.[f] ?? '').trim()).join('');
}

// Distinct devotionals for one day, oldest first. The earliest year wins when
// two rows carry the same content, so the current year keeps showing what it
// shows today.
export function variationsOf(rows) {
  const seen = new Map();
  for (const row of [...(rows || [])].sort((a, b) => (a.year || 0) - (b.year || 0))) {
    const key = contentSignature(row);
    if (!seen.has(key)) seen.set(key, row);
  }
  return [...seen.values()];
}

// Pick the devotional for a date out of that day's rows.
export function pickVariation(rows, dateStr) {
  const list = variationsOf(rows);
  if (!list.length) return null;
  const year = Number(String(dateStr).slice(0, 4));
  if (!Number.isFinite(year)) return list[0];
  const offset = ((year - CYCLE_ANCHOR) % list.length + list.length) % list.length;
  return list[offset];
}
